import { render, staticRenderFns } from "./OsCustomerForm.vue?vue&type=template&id=3b23258a&scoped=true"
import script from "./OsCustomerForm.vue?vue&type=script&lang=ts"
export * from "./OsCustomerForm.vue?vue&type=script&lang=ts"
import style0 from "./OsCustomerForm.vue?vue&type=style&index=0&id=3b23258a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b23258a",
  null
  
)

export default component.exports